import React from 'react'

// MUI Imports
import Pagination from '@mui/material/Pagination'
import Typography from '@mui/material/Typography'

export const TablePaginationComponentServerSide = ({ infoText1, infoText2, count = null, pageIndex = null, pageSize = null, setPageIndex }) => {
  return (
    <div className='flex justify-between items-center flex-wrap pli-6 border-bs bs-auto plb-[12.5px] gap-2'>
      <Typography color='text.disabled'>
        {`${infoText1} ${count} ${infoText2}`}
      </Typography>
      <Pagination
        shape='rounded'
        color='primary'
        variant='tonal'
        count={Math.ceil(count / pageSize)}
        page={pageIndex + 1}
        onChange={(_, page) => {
          setPageIndex(page - 1)
        }}
        showFirstButton
        showLastButton
      />
    </div>
  )
}

const TablePaginationComponent = ({ table, infoText1, infoText2 }) => {
  return (
    <div className='flex justify-between items-center flex-wrap pli-6 border-bs bs-auto plb-[12.5px] gap-2'>
      <Typography color='text.disabled'>
        {`${infoText1} ${table.getFilteredRowModel().rows.length} ${infoText2}`}
      </Typography>
      <Pagination
        shape='rounded'
        color='primary'
        variant='tonal'
        count={Math.ceil(table.getFilteredRowModel().rows.length / table.getState().pagination.pageSize)}
        page={table.getState().pagination.pageIndex + 1}
        onChange={(_, page) => {
          table.setPageIndex(page - 1)
        }}
        showFirstButton
        showLastButton
      />
    </div>
  )
}

export default TablePaginationComponent
